import {FormHelperText, IconButton, InputAdornment, InputLabel} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import {BootstrapInput} from "./BootstrapInput";
import React, {FocusEventHandler, useState} from "react";

interface CustomInputProps {
    id: string;
    name: string;
    label?: string;
    type: string;
    value?: string | null;
    error?: boolean;
    errorText?: string;
    helperText?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    onBlur?: FocusEventHandler<HTMLInputElement>;
    disabled?: boolean;
    placeholder?: string;
}

const CustomInput: React.FC<CustomInputProps> = ({
                                                     id,
                                                     name,
                                                     label,
                                                     type,
                                                     value,
                                                     error = false,
                                                     errorText,
                                                     helperText,
                                                     onChange,
                                                     onBlur,
                                                     disabled = false,
                                                     placeholder
                                                 }) => {
    // Password fields get a reveal toggle; admins type generated passwords and
    // need to see what they are about to hand a client.
    const [revealed, setRevealed] = useState(false);
    const isPassword = type === 'password';
    return (
        <>
            {label && <InputLabel htmlFor={id} sx={{left: "-13px"}} shrink>
                {label}
            </InputLabel>}
            <BootstrapInput
                id={id}
                name={name}
                type={isPassword && revealed ? 'text' : type}
                value={value}
                aria-describedby={`${id}-helper-text`}
                error={error}
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
                placeholder={placeholder}
                endAdornment={isPassword && (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label={revealed ? 'הסתר סיסמה' : 'הצג סיסמה'}
                            onClick={() => setRevealed(!revealed)}
                            edge="end"
                            size="small"
                            tabIndex={-1}
                        >
                            {revealed ? <VisibilityOffOutlinedIcon fontSize="small"/>
                                      : <VisibilityOutlinedIcon fontSize="small"/>}
                        </IconButton>
                    </InputAdornment>
                )}
            />
            {!error && helperText && (
                <FormHelperText id={`${id}-helper-text`} sx={{ml: 0}}>
                    {helperText}
                </FormHelperText>
            )}
            {error && errorText && (
                <FormHelperText id={`${id}-helper-text`} sx={{ml: 0}} error>
                    {errorText}
                </FormHelperText>
            )}
        </>
    );
};

export default CustomInput;
